<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Raporty TU'" [name]="'Lista importów'"></app-breadcrumb>
<div class="commission-import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="commission-import-list-filters">
    <app-month-picker
      class="commission-import-list-filter"
      label="Miesiąc rozliczeniowy" [required]="false"
      name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
    ></app-month-picker>

    <mat-form-field class="commission-import-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Nazwa.csv" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <app-dict
      [multiple]="false" label="Firma"
      class="commission-import-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-insurance-companies
      [multiple]="true" label="TU"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="true" label="Importer"
      class="commission-import-list-filter"
      [dictType]="'commission_importer_' + (selectedInsuranceCompanies.length > 0 ? selectedInsuranceCompanies[0].key : '')"
      [(ngModel)]="initialFilters.in$importer" name="in$importer"
    ></app-dict>

    <app-datepicker
      class="commission-import-list-filter"
      label="Data importu od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="commission-import-list-filter"
      label="Data importu do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict-users
      label="Użytkownik"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.createdBy" name="createdBy"
    ></app-dict-users>

    <app-dict
      [multiple]="false" label="Status"
      class="commission-import-list-filter"
      dictType="import_status"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <mat-form-field>
      <mat-label>Typ importu</mat-label>
      <mat-select [(ngModel)]="initialFilters.importType" name="importType" [multiple]="true">
        <mat-option [value]="'standard'">Standardowy</mat-option>
        <mat-option [value]="'overCommission'">Nadprowizja</mat-option>
        <mat-option [value]="'cancellation'">Storno</mat-option>
        <mat-option [value]="'profitImport'">Profitowi</mat-option>
        <mat-option [value]="'additionalSettlement'">Dodatkowe rozliczenie</mat-option>
      </mat-select>

    </mat-form-field>

  </form>

  <div class="commission-import-list-buttons">
    <button *ngIf="(userPermissions | async).registration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="imports" [trackBy]="trackTask">
    <ng-container matColumnDef="billingMonth">
      <th mat-header-cell *matHeaderCellDef> Miesiąc rozliczeniowy </th>
      <td mat-cell *matCellDef="let element">
        {{element.billingMonth}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        <div class="statusChange-flex-container">
          <mat-chip-list *ngIf="element.profitImport" >
            <mat-chip class="statusChange-button-container chip-profit" matTooltip="Profitowy">PF</mat-chip>
          </mat-chip-list>
          <mat-chip-list *ngIf="element.overCommission" >
            <mat-chip class="statusChange-button-container" color="primary"  matTooltip="Nadprowizja">N</mat-chip>
          </mat-chip-list>
          <mat-chip-list *ngIf="element.cancellation" >
            <mat-chip class="statusChange-button-container chip-yellow" selected matTooltip="Storno">S</mat-chip>
          </mat-chip-list>
          <mat-chip-list *ngIf="element.additionalSettlement" >
            <mat-chip class="statusChange-button-container chip-additional-settlement" selected matTooltip="Dodatkowe rozliczenie">D</mat-chip>
          </mat-chip-list>
          {{element.name}}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="importer">
      <th mat-header-cell *matHeaderCellDef> Importer </th>
      <td mat-cell *matCellDef="let element">
        {{element.importer?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <div class="circular-image">
            <img class="circular-image small-avatar import-list-avatar"
                 [src]="'/rest/sso/api/user/' + element.createdBy.uuid + '/avatar'" (error)="onImgError($event)"
                 alt="Zdjęcie"/>
          </div>
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName}} {{element.createdBy.lastName}}</a>
        </ng-container>
        <ng-container *ngIf="!element.createdBy">
          System
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="sum">
      <th mat-header-cell *matHeaderCellDef>
        Prowizja / Inkaso
      </th>
      <td mat-cell *matCellDef="let element">
        {{(element.commissionSum !== null ? element.commissionSum : 0) | number:'1.2-2'}} zł /
        {{(element.collectionSum !== null ? element.collectionSum : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="totalRows">
      <th mat-header-cell *matHeaderCellDef> Liczba wierszy </th>
      <td mat-cell *matCellDef="let element">
        {{element.importedRows}}/{{element.totalRows}}
        <ng-container *ngIf="element.pkgTotal > 0">
         <br>K: {{element.pkgRows}}/{{element.pkgTotal}}
        </ng-container>
        <mat-progress-bar *ngIf="element.status.key === IMPORT_STATUS_IN_PROGRESS"
          class="example-margin"
          [color]="color"
          [mode]="mode"  >
        </mat-progress-bar>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div fxLayout="column" >
          <button  fxFlex="100"  mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
            <mat-menu #menu="matMenu" xPosition="before">
              <button *ngIf="(userPermissions | async).settlement.read_report" mat-menu-item (click)="downloadImportFile(element)">Pobierz plik importu</button>
              <button *ngIf="(userPermissions | async).settlement.read_report" mat-menu-item (click)="downloadReportFile(element)">Pobierz raport</button>
              <button *ngIf="(userPermissions | async).settlement.read_report" mat-menu-item (click)="downloadErrorsReport(element)">Pobierz raport błędów</button>
              <button *ngIf="(userPermissions | async).settlement.delete" [disabled]="!(userPermissions | async).settlement.delete" mat-menu-item (click)="deleteImport(element)">Usuń</button>
            </mat-menu>
<!--              <mat-progress-bar *ngIf="progressBarDelete === element.uuid"  [color]="color" [mode]="mode"> </mat-progress-bar>-->
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
